import { createFileRoute } from "@tanstack/react-router";
import { FundManagers } from "@/components/FundManagers";

export const Route = createFileRoute("/_authenticated/fund-managers/")({
  component: FundManagers,
  staticData: { page: "deals" },
});
